import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LegalDocumentText } from "@/components/legal/legal-document";
import { PageShell } from "@/components/ui";
import type { LegalDocument } from "@/lib/legal";
import { fetchTenantBootstrap } from "@/services/api/tenants";

/** H4: public `/t/<slug>/terms` and `/t/<slug>/privacy` (no sign-in needed). */
function TenantLegalPage({ doc }: { doc: LegalDocument }) {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  // The same query (and cache) as the tenant layout — no extra request.
  const bootstrapQuery = useQuery({
    queryKey: ["tenant-bootstrap", tenantSlug],
    queryFn: () => fetchTenantBootstrap(tenantSlug),
    enabled: Boolean(tenantSlug),
  });
  const schoolName = bootstrapQuery.data?.tenant.name ?? tenantSlug;
  return (
    <PageShell width="prose" data-testid={`tenant-${doc}-page`}>
      <LegalDocumentText
        doc={doc}
        schoolName={schoolName}
        isDraft={bootstrapQuery.data?.tenant.termsDraft === true}
        contactEmail={bootstrapQuery.data?.tenant.privacyContactEmail ?? null}
      />
    </PageShell>
  );
}

export function TenantTermsPage() {
  return <TenantLegalPage doc="terms" />;
}

export function TenantPrivacyPage() {
  return <TenantLegalPage doc="privacy" />;
}
